export default __webpack_public_path__ + "assets/images/b3726e8a0fb9594281ed9d8d164a3b45.jpg";